import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../context";
import { PrescriptionTemplateDetail, TemplateType } from "../../interfaces";

interface UpdateTemplateProps {
  templateId: string;
  name: string;
  templateType: TemplateType;
  prescriptionDetails: PrescriptionTemplateDetail[];
}

export const useUpdateTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ templateId, ...data }: UpdateTemplateProps) => {
      return api({
        method: "PATCH",
        url: `/templates/${templateId}`,
        data: JSON.stringify(data),
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["templates"] });
      queryClient.invalidateQueries({
        queryKey: ["template", variables.templateId],
      });
    },
  });
};
